import React from "react";
import { storyblokEditable } from "gatsby-source-storyblok"
import FlightExampleItem from "./flightExampleItem"

const FlightExampleSection = ({ blok }) => {
  // console.log(blok)

  return(
    <div className="mb-16 flex flex-col justify-center" {...storyblokEditable(blok)}>
      <div className="text-3xl font-bold mb-6">{blok.month}</div>
      <div className="lg:w-[750px] flex flex-wrap gap-2 justify-center">
        { blok.exampleItems?.map((item, i) => <FlightExampleItem blok={item} key={i} />)}
      </div>
    </div>
  ) 
}

export default FlightExampleSection
